var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 713.8 767.1",
    viewBox: "0 0 713.8 767.1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#f);}\n\t.st1{fill:url(#e);}\n\t.st2{fill:url(#d);}\n\t.st3{fill:url(#c);}\n\t.st4{fill:url(#b);}\n\t.st5{fill:url(#a);}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.8526 0 0 2.7127 640.02 499.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.2251 -2.2251)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -123.38,
    x2: -122.38,
    y1: -65.86,
    y2: -65.86,
    gradientTransform: "matrix(713.51 0 0 -678.52 87933 -44669)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C77C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ABA7F",
    offset: 0.4012
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355A97",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-100.8 19.1c0-17.5 7.1-33.4 18.6-44.9 3-3 6.4-5.8 10-8.1 4.1-2.7 8.6-5 13.3-6.7 4.8-1.7 9.8-2.9 15-3.4 2.2-0.2 4.4-0.3 6.6-0.3 4.9 0 9.7 0.6 14.2 1.6l34.7 34.6v38l-44.2-44.2v38.1l-21.2-21.3c-4.3 4.2-6.9 10.1-6.9 16.6 0 12.9 10.5 23.4 23.4 23.4 6.5 0 12.3-2.6 16.6-6.9l14.1 14.1 14.2 14.3c-11.5 11.5-27.4 18.6-44.9 18.6-35.1 0-63.5-28.4-63.5-63.5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2251 0 0 -2.2251 63.285 79.112)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -151.85,
    x2: -150.85,
    y1: -30.309,
    y2: -30.309,
    gradientTransform: "matrix(352.45 0 0 -335.17 53449 -10139)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C8ACB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36429F",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m-72.3-8.5c2.2-0.2 4.4-0.3 6.6-0.3 4.9 0 9.7 0.6 14.2 1.6l34.7 34.7v19.5l-55.5-55.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2251 0 0 -2.2251 46.629 58.271)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -144.36,
    x2: -143.36,
    y1: -39.674,
    y2: -39.674,
    gradientTransform: "matrix(447.47 0 0 -425.53 64515 -16863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C77C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ABA7F",
    offset: 0.4012
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355A97",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m-53.5 11.9-26.3-26.3c4.8-1.7 9.8-2.9 15-3.4l55.5 55.5v18.4l-44.2-44.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2251 0 0 -2.2251 -17.336 81.321)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -115.91,
    x2: -115.91,
    y1: -28.981,
    y2: 145.02,
    gradientTransform: "matrix(6.3473 0 0 6.0361 691.14 170.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17EAD9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6078EA",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m-64.4 2.6c4.1-2.7 8.6-5 13.3-6.7l26.3 26.3v20l-39.6-39.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2251 0 0 -2.2251 1.997 -14.169)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -124.3,
    x2: -123.3,
    y1: -72.23,
    y2: -72.23,
    gradientTransform: "matrix(470.86 0 0 -447.78 58444 -32324)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C8ACB",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36429F",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m-81.7 12.7c0-12 4.9-22.9 12.8-30.7l14.2 14.1c-4.3 4.2-6.9 10.1-6.9 16.6 0 12.9 10.5 23.4 23.4 23.4 6.5 0 12.3-2.6 16.6-6.9l14.1 14.1c-7.9 7.9-18.7 12.8-30.7 12.8-24 0.1-43.5-19.4-43.5-43.4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2251 0 0 -2.2251 -4.5036 -20.692)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -121.36,
    x2: -120.36,
    y1: -75.16,
    y2: -75.16,
    gradientTransform: "matrix(687.81 0 0 -654.09 83373 -49142)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C77C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ABA7F",
    offset: 0.4012
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#355A97",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m-98.8 9.8c0-17.5 7.1-33.4 18.6-44.9l14.2 14.2c-7.9 7.9-12.8 18.7-12.8 30.7 0 24 19.5 43.5 43.5 43.5 12 0 22.9-4.9 30.7-12.8l14.2 14.2c-11.5 11.5-27.3 18.6-44.9 18.6-35 0-63.5-28.4-63.5-63.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.d84914799ea9aa935660dc258d22bf1f.svg";
export { ForwardRef as ReactComponent };